/* eslint-disable jsx-a11y/heading-has-content */
import ReactMarkdown, { Components } from "react-markdown";
import rehypeRaw from "rehype-raw";
import { FigmaTypography } from "@libs/zapi-ui/custom";

export const markdownComponents: Components = {
  a: ({ node: _node, ...props }) => {
    const isInternal =
      props.href?.startsWith("/") || props.href?.includes("platform.innovera") || props.href?.includes("localhost");
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        {...props}
        {...(isInternal ? {} : { target: "_blank", rel: "noopener noreferrer" })}
        className="underline text-[#3367E5]"
      />
    );
  },
  p: ({ node: _node, ...props }) => <p {...props} className="mb-2 last:mb-0" />,
  ul: ({ node: _node, ...props }) => <ul {...props} className="list-disc pl-5 mb-2 last:mb-0" />,
  ol: ({ node: _node, ...props }) => <ol {...props} className="list-decimal pl-5 mb-2 last:mb-0" />,
  li: ({ node: _node, ...props }) => <li {...props} className="mb-1" />,
  h1: ({ node: _node, color: _color, ...props }) => <FigmaTypography component="h1" variant="memo-heading-2" {...props} className="mb-2" />,
  h2: ({ node: _node, color: _color, ...props }) => <FigmaTypography component="h2" variant="memo-heading-3" {...props} className="mb-2" />,
  h3: ({ node: _node, color: _color, ...props }) => <FigmaTypography component="h3" variant="memo-body-semibold" {...props} className="mb-2" />,
  strong: ({ node: _node, ...props }) => <strong {...props} className="font-semibold" />
};

export function MessageMarkdown({ content }: { content: string }) {
  return (
    <div className="w-full text-[14px] leading-[22px] text-innoveraZinc-900">
      <ReactMarkdown rehypePlugins={[rehypeRaw]} components={markdownComponents}>
        {content || ""}
      </ReactMarkdown>
    </div>
  );
}
